import React from 'react';
import { IconButton } from '@mui/material';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const EmptyState = ({ imageSrc, type, onAddClick }) => {
  return (
    <div
      style={{
        height: '100%',
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <img src={imageSrc} alt="Empty State" style={{ height: '24px', width: '24px' }} />
      <p style={{ margin: 0, color: '#888' }}>No {type}s found.</p>
      {onAddClick && (
        <p style={{ margin: 0 }}>
          <span style={{ color: '#888' }}>Press</span>
          <IconButton color="inherit" onClick={onAddClick} size="small">
            <AddCircleOutlineOutlinedIcon />
          </IconButton>{' '}
          <span style={{ color: '#888' }}>to add a new {type}</span>
        </p>
      )}
    </div>
  );
};

export default EmptyState;
